import React from "react";
import AlgorithmConfig from "./AlgorithmConfig";

const PostAlgorithm = () => (
  <AlgorithmConfig feedType="post" heading="POST ALGORITHM" />
);

export default PostAlgorithm;
